import 'swiper/css';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';
import { Mousewheel, Keyboard } from 'swiper/modules';
import FashionImg from '../../assets/fashion.webp'

const TopFashion = () => {

    return (
        <div className=" container py-4">
            <div className=" p-2 bg-white shadow-lg rounded-md">
                <div className=" text-2xl font-semibold mb-2">Top Fashion Deals</div>
                <div className=" w-full">
                    <Swiper
                        // spaceBetween={5}
                        slidesPerView={"auto"}
                        centeredSlides
                        loop
                        mousewheel={true}
                        keyboard={true}
                        autoplay={{
                            delay: 2500,
                            disableOnInteraction: false
                        }}
                        breakpoints={{
                            640: {
                                slidesPerView: 2,
                                // spaceBetween: 20,
                            },
                            768: {
                                slidesPerView: 3,
                                // spaceBetween: 40,
                            },
                            1024: {
                                slidesPerView: 4,
                                // spaceBetween: 50,
                            },
                            1280: {
                                slidesPerView: 6,
                                // spaceBetween: 50,
                            },
                        }}
                        modules={[Autoplay, Mousewheel, Keyboard]}
                    >
                        {
                            topFashionList.map((item, index) => (
                                <SwiperSlide key={index}>
                                    <a href='#/' className=" aspect-square p-2 flex flex-col group cursor-pointer">
                                        <div className=" flex-1 rounded-md overflow-hidden border-2 border-slate-300">
                                            <img src={item.img} className=' w-full h-full object-cover group-hover:scale-105 transition' alt="" />
                                        </div>
                                        <div className=" py-2">
                                            <div className=" truncate">{item.title}</div>
                                            <div className=" font-semibold">&#8358; {item.price.toLocaleString()}</div>
                                        </div>
                                    </a>
                                </SwiperSlide>
                            ))
                        }
                    </Swiper>
                </div>
            </div>
        </div>
    )
}

export default TopFashion

const topFashionList = [
    { img: FashionImg, title: "Jewelry Scarf Ring Gold Silver Vintage Brooch Pins", price: 12000 },
    { img: FashionImg, title: "Jewelry Scarf Ring Gold Silver Vintage Brooch Pins", price: 12000 },
    { img: FashionImg, title: "Jewelry Scarf Ring Gold Silver Vintage Brooch Pins", price: 12000 },
    { img: FashionImg, title: "Jewelry Scarf Ring Gold Silver Vintage Brooch Pins", price: 12000 },
    { img: FashionImg, title: "Jewelry Scarf Ring Gold Silver Vintage Brooch Pins", price: 12000 },
    { img: FashionImg, title: "Jewelry Scarf Ring Gold Silver Vintage Brooch Pins", price: 12000 },
    { img: FashionImg, title: "Jewelry Scarf Ring Gold Silver Vintage Brooch Pins", price: 12000 },
    { img: FashionImg, title: "Jewelry Scarf Ring Gold Silver Vintage Brooch Pins", price: 12000 },
    { img: FashionImg, title: "Jewelry Scarf Ring Gold Silver Vintage Brooch Pins", price: 12000 },
    { img: FashionImg, title: "Jewelry Scarf Ring Gold Silver Vintage Brooch Pins", price: 12000 },
    { img: FashionImg, title: "Jewelry Scarf Ring Gold Silver Vintage Brooch Pins", price: 12000 },
    { img: FashionImg, title: "Jewelry Scarf Ring Gold Silver Vintage Brooch Pins", price: 12000 },
    { img: FashionImg, title: "Jewelry Scarf Ring Gold Silver Vintage Brooch Pins", price: 12000 },
    { img: FashionImg, title: "Jewelry Scarf Ring Gold Silver Vintage Brooch Pins", price: 12000 },
    { img: FashionImg, title: "Jewelry Scarf Ring Gold Silver Vintage Brooch Pins", price: 12000 },
    { img: FashionImg, title: "Jewelry Scarf Ring Gold Silver Vintage Brooch Pins", price: 12000 },
]